/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/bolmatePassword.scss';

import React, {FocusEventHandler, InputHTMLAttributes, KeyboardEventHandler, PureComponent} from 'react';
import {AwesomeIcon, ElementPosition, ErrorType} from '@dvrd/dvr-controls';
import {BolmateInput} from "../index";

interface Props {
    onChange: (value: string, evt: React.ChangeEvent) => void;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
    onKeyDown?: KeyboardEventHandler;
    onEnter?: KeyboardEventHandler;
    value: string | number;
    label?: string;
    inputProps?: InputHTMLAttributes<any>;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
    inputClassName?: string;
    labelClassName?: string;
    ornamentClassName?: string;
    errorClassName?: string;
    error?: ErrorType;
    id?: string;
}

interface State {
    type: 'password' | 'text';
}

export default class BolmatePasswordInput extends PureComponent<Props, State> {
    state: State = {
        type: 'password',
    };

    onClickOrnament = () => {
        const {type} = this.state;
        if (type === 'password') this.setState({type: 'text'});
        else this.setState({type: 'password'});
    };

    renderOrnament = () => {
        const {type} = this.state, element = type === 'password' ? 'eye' : 'eye-slash';
        return {
            placement: ElementPosition.RIGHT,
            element: <AwesomeIcon name={element} onClick={this.onClickOrnament} className='bolmate-password-toggle'/>
        };
    };

    render = () => {
        const {type} = this.state, {inputProps} = this.props;
        return (
            <BolmateInput {...this.props} inputProps={{...inputProps, type}} ornaments={this.renderOrnament()}/>
        );
    }
}